import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Rx'
import { alertError, alertSuccess } from 'store/ducks/alert'
import {
  addUserClient,
  getCustomPage,
  getUserById,
  updateCustomSettings,
  updateInterface,
  updateUserClient,
} from '../services/customize'

import { intl } from 'i18n/index'
// Actions
export const INIT_CUSTOMIZE_INTERFACE_REQUEST = 'customize/INIT_CUSTOMIZE_INTERFACE_REQUEST'

export const UPDATE_CUSTOMIZE_INTERFACE_REQUEST = 'customize/UPDATE_CUSTOMIZE_INTERFACE_REQUEST'
export const UPDATE_CUSTOMIZE_INTERFACE_SUCCESS = 'customize/UPDATE_CUSTOMIZE_INTERFACE_SUCCESS'
export const UPDATE_CUSTOMIZE_INTERFACE_FAILURE = 'customize/UPDATE_CUSTOMIZE_INTERFACE_FAILURE'

export const FETCH_CUSTOM_PAGE_REQUEST = 'customize/FETCH_CUSTOM_PAGE_REQUEST'
export const FETCH_CUSTOM_PAGE_SUCCESS = 'customize/FETCH_CUSTOM_PAGE_SUCCESS'
export const FETCH_CUSTOM_PAGE_FAILURE = 'customize/FETCH_CUSTOM_PAGE_FAILURE'

export const ADD_USERS_REQUEST = 'customize/ADD_USERS_REQUEST'
export const ADD_USERS_SUCCESS = 'customize/ADD_USERS_SUCCESS'
export const ADD_USERS_FAILURE = 'customize/ADD_USERS_FAILURE'

export const FETCH_USER_BY_ID_REQUEST = 'customize/FETCH_USER_BY_ID_REQUEST'
export const FETCH_USER_BY_ID_SUCCESS = 'customize/FETCH_USER_BY_ID_SUCCESS'
export const FETCH_USER_BY_ID_FAILURE = 'customize/FETCH_USER_BY_ID_FAILURE'

export const UPDATE_USERS_REQUEST = 'customize/UPDATE_USERS_REQUEST'
export const UPDATE_USERS_SUCCESS = 'customize/UPDATE_USERS_SUCCESS'
export const UPDATE_USERS_FAILURE = 'customize/UPDATE_USERS_FAILURE'

export const UPDATE_CUSTOMIZE_SETTINGS_REQUEST = 'customize/UPDATE_CUSTOMIZE_SETTINGS_REQUEST'
export const UPDATE_CUSTOMIZE_SETTINGS_SUCCESS = 'customize/UPDATE_CUSTOMIZE_SETTINGS_SUCCESS'
export const UPDATE_CUSTOMIZE_SETTINGS_FAILURE = 'customize/UPDATE_CUSTOMIZE_SETTINGS_FAILURE'
export const RESET_USER = 'customize/RESET_USER'

// Reducer
const INITIAL_STATE = {
  customPage: null,
  loading: false,
  users: [],
  userById: null,
  departments: {
    all: [],
    loading: false,
  },
}

export function reducer(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case INIT_CUSTOMIZE_INTERFACE_REQUEST:
      return {
        ...state,
        loading: true,
        customPage: action.customPage,
      }
    case UPDATE_CUSTOMIZE_INTERFACE_REQUEST:
      return {
        ...state,
        loading: true,
      }

    case UPDATE_CUSTOMIZE_INTERFACE_SUCCESS:
      return {
        ...state,
        loading: false,
        customPage: action.payload,
      }
    case UPDATE_CUSTOMIZE_INTERFACE_FAILURE:
      return {
        ...state,
        loading: false,
      }

    case FETCH_CUSTOM_PAGE_REQUEST:
      return {
        ...state,
        loading: true,
      }

    case FETCH_CUSTOM_PAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        customPage: action.customPage,
        users: action.users,
      }
    case FETCH_CUSTOM_PAGE_FAILURE:
      return {
        ...state,
        loading: false,
      }

    case ADD_USERS_REQUEST:
      return {
        ...state,
        loading: true,
      }

    case ADD_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        users: [...state.users, action.user],
      }
    case ADD_USERS_FAILURE:
      return {
        ...state,
        loading: false,
      }

    case FETCH_USER_BY_ID_REQUEST:
      return {
        ...state,
        loading: true,
      }

    case FETCH_USER_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        userById: action.user,
      }
    case FETCH_USER_BY_ID_FAILURE:
      return {
        ...state,
        loading: false,
      }

    case UPDATE_USERS_REQUEST:
      return {
        ...state,
        loading: true,
      }

    case UPDATE_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        users: state.users.map((existingUser) => (existingUser.id === action.user.id ? action.user : existingUser)),
      }
    case UPDATE_USERS_FAILURE:
      return {
        ...state,
        loading: false,
      }
    case RESET_USER:
      return {
        ...state,
        loading: false,
        userById: undefined,
      }

    case UPDATE_CUSTOMIZE_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true,
        departments: { ...state.departments, loading: true },
      }

    case UPDATE_CUSTOMIZE_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        customPage: action.customizeSettings,
        departments: { ...state.departments, loading: false },
      }
    case UPDATE_CUSTOMIZE_SETTINGS_FAILURE:
      return {
        ...state,
        loading: false,
        departments: { ...state.departments, loading: false },
      }
    default:
      return state
  }
}

// Actions Creators

export const initCustomizeInterface = (customPage) => ({
  type: INIT_CUSTOMIZE_INTERFACE_REQUEST,
  customPage,
})

export const updateCustomizeInterface = (payload) => {
  return {
    type: UPDATE_CUSTOMIZE_INTERFACE_REQUEST,
    payload,
  }
}

export const updateCustomizeInterfaceSuccess = (payload) => ({
  type: UPDATE_CUSTOMIZE_INTERFACE_SUCCESS,
  payload,
})

export const updateCustomizeInterfaceFailure = () => ({
  type: UPDATE_CUSTOMIZE_INTERFACE_FAILURE,
})

export const fetchCustomPage = (customPageID) => {
  return {
    type: FETCH_CUSTOM_PAGE_REQUEST,
    customPageID,
  }
}

export const fetchCustomPageSuccess = ({ customPage, users }) => {
  return {
    type: FETCH_CUSTOM_PAGE_SUCCESS,
    customPage,
    users,
  }
}

export const fetchCustomPageFailure = () => ({
  type: FETCH_CUSTOM_PAGE_FAILURE,
})

export const addUser = (user) => {
  return {
    type: ADD_USERS_REQUEST,
    user,
  }
}

export const addUserSuccess = (user) => {
  return {
    type: ADD_USERS_SUCCESS,
    user,
  }
}

export const addUserFailure = () => ({
  type: ADD_USERS_FAILURE,
})

export const fetchUserById = (id) => {
  return {
    type: FETCH_USER_BY_ID_REQUEST,
    id,
  }
}

export const fetchUserByIdSuccess = (user) => {
  return {
    type: FETCH_USER_BY_ID_SUCCESS,
    user,
  }
}

export const fetchUserByIdFailure = () => ({
  type: FETCH_USER_BY_ID_FAILURE,
})

export const updateUser = (user, userId) => {
  return {
    type: UPDATE_USERS_REQUEST,
    user,
    userId,
  }
}

export const updateUserSuccess = (user) => {
  return {
    type: UPDATE_USERS_SUCCESS,
    user,
  }
}

export const updateUserFailure = () => ({
  type: UPDATE_USERS_FAILURE,
})

export const resetUser = () => ({
  type: RESET_USER,
})

export const updateCustomizeSettings = (customizeSettings) => {
  return {
    type: UPDATE_CUSTOMIZE_SETTINGS_REQUEST,
    customizeSettings,
  }
}

export const updateCustomizeSettingsSuccess = (customizeSettings) => {
  return {
    type: UPDATE_CUSTOMIZE_SETTINGS_SUCCESS,
    customizeSettings,
  }
}

export const updateCustomizeSettingsFailure = () => ({
  type: UPDATE_CUSTOMIZE_SETTINGS_FAILURE,
})

// Epics
export const epic = combineEpics(
  updateCustomizeInterfaceEpic,
  fetchCustomPageEpic,
  addUsersEpic,
  fetchUserByIdEpic,
  updateUserEpic,
  updateCustomizeSettingsEpic,
)

export function updateCustomizeInterfaceEpic(action$) {
  return action$.ofType(UPDATE_CUSTOMIZE_INTERFACE_REQUEST).mergeMap((action) => {
    return Observable.ajax(updateInterface(action.payload))
      .mergeMap((res) =>
        Observable.of(
          updateCustomizeInterfaceSuccess(res.response),
          alertSuccess(intl.formatMessage({ id: 'ducks.customize.customPage.update.success' })),
        ),
      )
      .catch(() => {
        return Observable.of(
          alertError(intl.formatMessage({ id: 'ducks.customize.customPage.update.error' })),
          updateCustomizeInterfaceFailure(),
        )
      })
  })
}

export function fetchCustomPageEpic(action$) {
  return action$.ofType(FETCH_CUSTOM_PAGE_REQUEST).mergeMap((action) => {
    return Observable.ajax(getCustomPage(action.customPageID))
      .map((res) => fetchCustomPageSuccess({ customPage: { ...res.response }, users: res.response.users }))
      .catch((err) => {
        return Observable.of(alertError(err.message), fetchCustomPageFailure())
      })
  })
}

export function addUsersEpic(action$) {
  return action$.ofType(ADD_USERS_REQUEST).mergeMap((action) => {
    return Observable.ajax(addUserClient(action.user))
      .mergeMap((res) =>
        Observable.of(
          addUserSuccess(res.response),
          alertSuccess(intl.formatMessage({ id: 'ducks.customize.customUsers.add.success' })),
        ),
      )
      .catch(() => {
        return Observable.of(
          alertError(intl.formatMessage({ id: 'ducks.customize.customUsers.add.error' })),
          addUserFailure(),
        )
      })
  })
}

export function fetchUserByIdEpic(action$) {
  return action$.ofType(FETCH_USER_BY_ID_REQUEST).mergeMap((action) => {
    return Observable.ajax(getUserById(action.id))
      .map((res) => {
        return fetchUserByIdSuccess(res.response)
      })
      .catch((err) => {
        return Observable.of(alertError(err.message), fetchUserByIdFailure())
      })
  })
}

export function updateUserEpic(action$) {
  return action$.ofType(UPDATE_USERS_REQUEST).mergeMap((action) => {
    return Observable.ajax(updateUserClient(action.user, action.userId))
      .mergeMap((res) =>
        Observable.of(
          updateUserSuccess(res.response),
          alertSuccess(intl.formatMessage({ id: 'ducks.customize.customUsers.update.success' })),
        ),
      )
      .catch(() => {
        return Observable.of(
          alertError(intl.formatMessage({ id: 'ducks.customize.customUsers.update.error' })),
          updateUserFailure(),
        )
      })
  })
}

export function updateCustomizeSettingsEpic(action$) {
  return action$.ofType(UPDATE_CUSTOMIZE_SETTINGS_REQUEST).mergeMap((action) => {
    return Observable.ajax(updateCustomSettings(action.customizeSettings))
      .mergeMap((res) =>
        Observable.of(
          updateCustomizeSettingsSuccess(res.response),
          alertSuccess(intl.formatMessage({ id: 'ducks.customize.customizeSettings.update.success' })),
        ),
      )
      .catch(() => {
        return Observable.of(
          alertError(intl.formatMessage({ id: 'ducks.customize.customizeSettings.update.error' })),
          updateCustomizeSettingsFailure(),
        )
      })
  })
}
